<!--
 * @Description: 组织管理新
 * @Autor: xiaona.wang
 * @Date: 2021-12-01 20:57:00
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-09-09 15:08:41
-->

<template>
  <div class="app-wrap">
    <TreeListLayoutAdapter :left-panel-enable="false" :right-top-panel-enable="false">
      <template #search>
        <!-- 搜索框 -->
        <div class="search" style="height: 60px; padding: 24px">
          <el-form
            :inline="true"
            :model="searchForm"
            class="demo-form-inline"
            @submit.native.prevent
          >
            <el-form-item label="">
              <el-input
                v-model="searchForm.value"
                clearable
                style="width: 360px"
                :placeholder="$t('orgManage.searchPlaceHolder')"
                @keyup.enter.native="handleSearch"
              >
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search cursor-p"
                  @click="handleSearch"
                />
              </el-input>
            </el-form-item>

            <!-- 添加角色按钮，同步角色按钮 -->
            <el-form-item class="float-right" style="margin-right: 0">
              <el-button type="primary" @click="handleShow">
                {{ $t('orgManage.createOrg') }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template #datatable>
        <!-- todo 处理更多选项 -->
        <general-table
          ref="tableInstance"
          :code="tableCode"
          :table-sort-custom="tableSortCustom"
          :version="tableVersion"
          :columns="tableColumns"
          :data="tableData"
          :pagination="pagination"
          :loading="tableLoading"
          @refresh="handleRefresh"
          @handleSizeChange="handlePaginationChange"
          @handleCurrentChange="handlePaginationChange"
          @changeCustomSort="changeCustomSort"
        >
          <template #effect="{ item }">
            <el-switch
              v-model="item.effect"
              active-icon-class="el-icon-check"
              @change="changeSwitch(item)"
            ></el-switch>
          </template>
          <template #displayName="{ item }">
            {{ item.user ? item.user.displayName : '' }}
          </template>
          <template #operation="{ scope }">
            <el-button
              type="text"
              class="btn__text--no-padding"
              @click="handleShow(scope.row, 'details')"
            >
              {{ $t('common.view') }}
            </el-button>
          </template>

          <template #operationMore="{ scope }">
            <p class="self-popover-item text_detail" @click="handleShow(scope.row, 'edit')">
              {{ $t('common.edit') }}
            </p>
            <p class="self-popover-item error text_detail" @click="handleDeleteShow(scope.row)">
              {{ $t('common.delete') }}
            </p>
          </template>
        </general-table>
      </template>
    </TreeListLayoutAdapter>

    <!-- 表格删除确认框 start-->
    <delete-dialog
      layout="left"
      :visible.sync="deleteDialogVisible"
      :content="deleteContent"
      :loading.sync="deleteLoading"
      @confirm="handleDeleteConfirm"
    />
    <!-- /表格删除确认框 end-->
    <!-- 新增|编辑|查看|补录弹框 start-->
    <org-manage-add
      v-if="dialogInfoVisible"
      :visible.sync="dialogInfoVisible"
      @success="handleUpdateList"
    />
    <org-manage-edit
      v-if="editVisible"
      :visible.sync="editVisible"
      :org-data="dialogData"
      @success="handleUpdateList"
    />
    <org-manage-details
      v-if="detailsVisible"
      :visible.sync="detailsVisible"
      :org-data="dialogData"
    />
    <!-- 新增|编辑弹框 end-->
  </div>
</template>

<script>
import orgManageApi from "@/api/orgManage";
import { mapGetters } from "vuex";
import DeleteDialog from "@/components/common/Dialogs/DeleteDialog";
import tableApi from "@/api/general-table";
import OrgManageAdd from "./org-manage-add";
import OrgManageEdit from "./org-manage-edit";
import OrgManageDetails from "./org-manage-details";
export default {
  name: "OrgManageList",
  components: {
    DeleteDialog,
    OrgManageAdd,
    OrgManageEdit,
    OrgManageDetails
  },
  filters: {
    // 角色和组织数据列转换为对应的name
    dataTrans: value => {
      let role = "";
      if (value && value.length) {
        for (let i = 0; i < value.length; i++) {
          if (i === 0) {
            role = value[i].name;
          } else {
            role += `;${value[i].name}`;
          }
        }
      }
      return role;
    }
  },

  data() {
    return {
      tableLoading: false,
      dialogInfoVisible: false,
      deleteDialogVisible: false,
      editVisible: false,
      detailsVisible: false,
      deleteLoading: false,
      dialogData: {},
      loading: false,
      searchForm: {
        value: ""
      },
      tableData: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      deleteContent: {
        title: this.$t("org.deleteTitle"),
        description: this.$t("org.deleteText")
      },
      tableColumns: [
        {
          label: this.$t("orgManage.orgName"),
          key: "orgName",
          width: "200",
          fixed: false,
          hidden: false
        },
        {
          label: this.$t("orgManage.orgCode"),
          key: "orgCode",
          width: "200",
          fixed: false,
          hidden: false
        },
        {
          label: this.$t("orgManage.orgShortName"),
          key: "orgShortName",
          width: "180",
          fixed: false,
          hidden: false
        },
        {
          label: this.$t("orgManage.orgType"),
          key: "orgTypeName",
          width: "180",
          fixed: false,
          hidden: false
        },
        {
          label: this.$t("orgManage.orgManager"),
          key: "displayName",
          width: "180",
          fixed: false,
          hidden: false
        },
        {
          label: this.$t("org.isEffect"),
          key: "effect",
          width: "auto",
          fixed: false,
          hidden: false
        }
      ],
      tableCode: "TABLE_CODE_COMMON_ORG_MANAGE",
      tableVersion: 1,
      tableSortCustom: [],
      tableSortDisabled: [],
      deleteId: ""
    };
  },

  computed: {
    ...mapGetters(["tenantId"])
  },
  watch: {
    "searchForm.value"(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.handleSearch();
      }
    }
  },
  created() {
    // 获取组织树
    this.initTableData();
  },
  methods: {
    async initTableData() {
      this.tableSortCustom = [];
      if (this.tableCode) {
        const { data = {} } = await tableApi.getFormByCode(this.tableCode);
        const { orders } = data;
        orders && (this.tableSortCustom = orders);
      }
      // 获取列表数据
      this.getList();
    },
    changeCustomSort(sort) {
      this.tableSortCustom = sort;
      this.getList();
    },
    /**
     * @description: 搜索
     * @param {*}
     * @return {*}
     */
    handleSearch() {
      this.pagination.total = 0;
      this.pagination.pageNum = 1;
      this.tableData = [];
      this.getList();
    },
    changeSwitch(item) {
      const param = { effect: item.effect, id: item.id };
      orgManageApi.updateOrgEffect(param).then(() => {
        this.$message.success(this.$t("public.updatedSuccessfully"));
      });
    },
    // 创建修改编辑,
    handleShow(data = {}, type = "add") {
      this.dialogData = data;
      switch (type) {
        case "add":
          this.dialogInfoVisible = true;
          break;
        case "edit":
          this.editVisible = true;
          break;
        case "details":
          this.detailsVisible = true;
          break;
      }
    },
    // 获取组织列表数据
    getList() {
      this.tableLoading = true;
      const params = {
        page: this.pagination.pageNum,
        size: this.pagination.pageSize,
        tenantId: this.tenantId,
        search: this.searchForm.value
      };
      if (Array.isArray(this.tableSortCustom)) {
        for (let i = 0; i < this.tableSortCustom.length; i++) {
          const item = this.tableSortCustom[i];
          params[`orders[${i}].asc`] = item.asc;
          params[`orders[${i}].column`] = item.column;
        }
      }
      orgManageApi.getList(params).then(res => {
        this.tableLoading = false;
        const { data } = res;
        if (data) {
          const { records = [], total = 0 } = data;
          this.tableData = records;
          this.pagination.total = Number(total);
        }
      });
    },
    // 新增、编辑、删除、重置密码等弹框保存成功后回调：刷新列表
    handleUpdateList(isEdit) {
      if (!isEdit) {
        this.pagination.pageNum = 1;
      }
      this.getList();
    },
    // 条数改变|页数改变
    handlePaginationChange(data) {
      this.$set(this, "pagination", data);
      this.getList();
    },
    // table刷新
    handleRefresh() {
      this.$emit("refresh");
    },
    // 单行删除操作
    handleDeleteShow(row) {
      this.deleteId = row.id;
      this.deleteContent.title = this.$t("org.deleteTitle", [row.orgName]);
      this.deleteDialogVisible = true;
    },
    // 删除提交
    handleDeleteConfirm() {
      this.deleteLoading = true;
      orgManageApi
        .deleteItems(this.deleteId)
        .then(res => {
          this.deleteLoading = false;
          this.deleteDialogVisible = false;
          this.$message.success(this.$t("common.deleteSuccess"));
          this.handleUpdateList();
        })
        .catch(() => {
          this.deleteLoading = false;
          this.deleteDialogVisible = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
.app-wrap {
  width: 100%;
  height: 100%;
}

.self-drag-right {
  background-color: #fff;
  padding: 20px;
  .r-b-title {
    margin-bottom: 16px;
  }
}
::v-deep.self-filter-input .el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
}
</style>
